import React from "react";
import styled from "styled-components";
import IconSpinner from "./icons/IconSpinner";

type Props = {
  isShown?: boolean;
};

export const LoadingIndicator: React.FC<Props> = ({ isShown }) => {
  if (!isShown) return null;

  return (
    <LoadingContainer>
      <LoadingIcon>
        <IconSpinner />
      </LoadingIcon>
    </LoadingContainer>
  );
};

const LoadingContainer = styled.div`
  z-index: 10000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LoadingIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 440px;
  max-width: 90vw;
  height: 440px;
  border-radius: 0.75rem;
`;
